import { View } from 'react-native';

export const enableScreens = () => {};
export const ScreenContainer = View;
export const Screen = View;
export const NativeScreen = View;
export const ScreenStack = View;
export const ScreenStackHeaderConfig = View;
export const ScreenStackHeaderSubview = View;